import { Box, Skeleton } from '@mui/material'
import { DRAWER_WIDTH, HEADER_HEIGHT } from 'utils/customizedTheme'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'

const LayoutSkeleton = () => {
  const openNavigation = useSelector((state: RootState) => state.theme.openNavigation)

  return (
    <>
      <Box>
        {/* Header */}
        <Skeleton width={'100%'} height={`${HEADER_HEIGHT * 1.1}px`} sx={{ transform: 'none' }} />
      </Box>
      <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'space-between' }}>
        {/* Navigation */}
        {openNavigation && (
          <Skeleton
            width={`${DRAWER_WIDTH - 30}px`}
            height={'90vh'}
            sx={{ transform: 'none', marginTop: '2.5rem' }}
          />
        )}
        {/* Main */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            alignItems: 'center',
            marginTop: '1.6rem',
          }}
        >
          <Skeleton width={'94%'} height={'140px'} />
          {Array.from({ length: 3 }).map((el, i) => (
            <Skeleton key={i} width={'94%'} height={'70px'} sx={{ marginTop: '1.5rem' }} />
          ))}
        </Box>
      </Box>
    </>
  )
}

export default LayoutSkeleton
